module.exports = __webpack_public_path__ + "img/primary_3x1.8f536f87.svg";